module.exports = __webpack_public_path__ + "img/old-logo.2d0a90c9.png";